'use client';

import * as TogglePrimitive from '@radix-ui/react-toggle';
import { forwardRef, ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { Icon, type SvgIcon } from '../icon/icon';
import { ChevronDown } from '../../icons';

type FilterButtonProps = Omit<TogglePrimitive.ToggleProps, 'asChild'> & {
  children?: ReactNode;
  icon?: SvgIcon;
  chevronDirection?: 'up' | 'down';
  classNames?: {
    icon?: string;
  };
};

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ children, icon, chevronDirection, className, classNames, ...props }, ref) => (
    <TogglePrimitive.Root
      data-slot="toggle"
      ref={ref}
      className={cn(
        // Default
        'group flex h-8 cursor-pointer items-center justify-center gap-2 rounded-full border border-space-15 px-3 py-2 typo-sm text-space-75 transition-all duration-150 ease-out focus-visible:ring-[3px] focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:outline-none',
        // Hover
        'hover:bg-indigo-crush-04',
        // Active
        'data-[state=on]:bg-indigo-crush-04 [&[data-state=on]:not([data-disabled])]:border-indigo-crush [&[data-state=on]:not([data-disabled])]:text-indigo-crush',
        // Disabled
        'data-[disabled]:pointer-events-none data-[disabled]:cursor-not-allowed data-[disabled]:text-space/40 [&[data-state=on][data-disabled]]:border-indigo-crush/40 [&[data-state=on][data-disabled]]:text-indigo-crush/40',
        className,
      )}
      {...props}>
      {icon && <Icon icon={icon} className={cn('size-4', classNames?.icon)} />}
      {children}
      {chevronDirection && (
        <Icon
          icon={ChevronDown}
          className={cn(
            'size-4 transition-transform duration-250 ease-out',
            chevronDirection === 'up' ? 'rotate-180' : 'rotate-0',
          )}
        />
      )}
    </TogglePrimitive.Root>
  ),
);
FilterButton.displayName = 'FilterButton';
